import { DecimalPipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cmpsNumberWithSign',
})
export class CmpsNumberWithSign implements PipeTransform {
    // type n = number, p = percent
    transform(
        value: any,
        type: 'n' | 'p',
        roundFormat = '0.0',
        addPositiveSign = false,
        signToAdd = '+',
    ): string {
        const v = new DecimalPipe('en-US').transform(value, roundFormat);

        if (value == null) {
            return '-';
        }

        switch (type) {
            case 'p':
                // eslint-disable-next-line no-case-declarations
                const vp = new PercentPipe('en-US').transform(
                    value,
                    roundFormat,
                );
                if (!addPositiveSign) {
                    return vp;
                }
                return (value > 0 ? signToAdd : '') + vp;
            case 'n':
                if (!addPositiveSign) {
                    return v;
                }
                return (value > 0 ? signToAdd : '') + v;
            default:
                return v;
        }
    }
}
